import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {Icon} from 'react-fa';

import isString from 'lodash/isString';

import './Input.less';

class Input extends Component {
    constructor(props) {
        super(props);

        this.state = {placeholder: props.placeholder};
    };

    onFocus = () => {
        this.setState({
            placeholder: ''
        });
    };

    onBlur = () => {
        this.setState({
            placeholder: this.props.placeholder
        });
    };

    onChange = (e) => {
        const { onChange, input } = this.props;

        if (input) {
            input.onChange(e.target.value);
        } else if (onChange) {
            onChange(e.target.value);
        }
    };

    render() {

        const { isControlled, input, className, size, inline, font, grow, disabled, label, comment, inputType, name, value, meta, readOnly, icon, iconOnClick, onClick, inputRef, loading, isInvalid, ...props} = this.props;

        let labelElement = null;
        if (label) {
            labelElement = (
                <label className="Input-label" htmlFor="">
                    {label}
                    {comment && <em>{comment}</em>}
                </label>
            );
        }

        let inputValue = value;
        if (input) {
            inputValue = input.value;
        }

        return (
            <div className={classnames(className,
                `Input--size-${size}`,
                {
                    'Input--isInvalid': meta && meta.touched && meta.error || isInvalid,
                    'Input--grow': grow,
                    'Input--inline': inline,
                    'Input--disabled': disabled,
                    [`Input--font-${font}`]: font !== 'futura',
                    'Input--withIcon': icon
                }, 'Input')} onClick={onClick}>
                {labelElement}
                <div className="Input-content">
                    <input {...props}
                           type={inputType}
                           className="Input-input"
                           value={inputValue}
                           placeholder={this.state.placeholder}
                           name={name}
                           onFocus={this.onFocus}
                           onBlur={this.onBlur}
                           readOnly={readOnly}
                           disabled={this.props.isControlled || disabled}
                           ref={inputRef}
                           onChange={this.onChange}
                    />
                    {(icon || loading) &&
                    <div className={classnames({
                        [`Input-icon--${icon}`]: icon && isString(icon),
                        'Input-icon--active': iconOnClick
                    }, 'Input-icon')} onClick={iconOnClick}>
                        {(isString(icon) || loading) &&
                            <Icon name={loading && 'spinner' || icon} spin={loading}/>
                        }
                        {!isString(icon) && !loading && icon}
                    </div>
                    }
                </div>
            </div>
        );
    }
}

Input.defaultProps = {
    inputType: 'text',
    label: '',
    placeholder: '',
    size: 'normal',
    font: 'futura',
    grow: false,
    icon: undefined,
    isControlled: false,
    readOnly: false,
    inline: false,
    disabled: false
};

Input.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    size: PropTypes.string,
    font: PropTypes.string,
    value: PropTypes.string,
    inputType: PropTypes.oneOf(['text', 'password', 'email', 'number']),
    icon: PropTypes.node,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    iconOnClick: PropTypes.func
};

export default Input;



// WEBPACK FOOTER //
// ./assets/app/common/components/Input/Input.jsx